import pick from "lodash/pick";
import {
  AMP_AGENT_CONTEXT,
  type AmpAgentContext,
} from "@hightouch/lib/agent-harness/shared/context-schema";
import type { AgentContext } from "src/components/llm/agent-focus/agent-focus";
import { readPageContext } from "src/components/llm/agent-focus/read-page-context";

export function toAmpAgentContext(context: AgentContext): AmpAgentContext {
  return pick(context, Object.values(AMP_AGENT_CONTEXT));
}

/** The focused content of one sent v1 message, with the page the user sends it from. */
export function toV1FocusedContent(context: AgentContext): string {
  return formatV1FocusedContent({ ...context, page: readPageContext() });
}

/** V1 skill loading and activity memory read these fields at the top level. */
export function formatV1FocusedContent(context: AgentContext): string {
  const {
    contextHub,
    canvas,
    library,
    project,
    task,
    ads,
    emails,
    selectedSkills,
    page,
    ...legacy
  } = context;
  const focus = canvas
    ? { kind: "canvas", ...canvas }
    : library
      ? { kind: "library", ...library }
      : task
        ? { kind: "task", ...task }
        : project
          ? { kind: "project", ...project }
          : {};
  const style = ads?.style;
  const focused = {
    ...focus,
    creativeBoost: ads?.creativeBoost,
    useVideoEngine: ads?.useVideoEngine,
    adTemplates: ads?.templates,
    contextHub,
    emailStyle: emails?.style,
    emailTemplates: emails?.templates,
    emailComponents: emails?.components,
    ...(ads?.resize ? { action: { resize: ads.resize } } : {}),
    ...(selectedSkills?.length ? { selectedSkills } : {}),
    ...(page ? { page } : {}),
    ...(style?.mode === "style"
      ? { adStyle: { id: style.id, name: style.name } }
      : style?.mode === "none"
        ? { adStyle: "none" }
        : {}),
    ...legacy,
  };
  const serialized = JSON.stringify(focused);
  return serialized === "{}" ? "" : serialized;
}
